import Lottie from 'lottie-react'
import { memo, useMemo, useState } from 'react'
import {
  useTranslate,
  type Language,
} from '../../../hooks/language/use-translate'
import { useGetGameEnabledFirst } from '../../../hooks/queries/games/games-enableds/use-get-game-enabled-first.ts'
import { ModalGameGoldMiner } from '../modal-game-gold-miner/index.tsx'
import iconGameGoldMiner from './components/animations/game/icon-game-luck-surpise-box.json'

type GameScreen = 'menu' | 'luck-box'

export const ModalGames = memo(() => {
  const [currentScreen, setCurrentScreen] = useState<GameScreen>('menu')

  const { gameEnabled } = useGetGameEnabledFirst()
  const { translate } = useTranslate()

  const openGameModal = (gameKey: string) => {
    if (
      gameKey === 'luck-box' ||
      gameKey === 'lucky-bag' ||
      gameKey === 'roulette'
    ) {
      setCurrentScreen('luck-box')
    }
  }

  const handleCloseModal = () => {
    if ('ReactNativeWebView' in window) {
      // @ts-ignore
      window.ReactNativeWebView.postMessage('close-modal')
    }
  }

  const gameOptions = useMemo(() => {
    const options = [
      // { label: 'modal-games-roulette', key: 'roulette', enabled: true },
      // { label: 'modal-games-luck-bag', key: 'lucky-bag', enabled: true },
    ]

    // if (gameEnabled?.enableGameGoldMiner) {
    options.push({
      label: 'modal-games-golds-miners',
      key: 'luck-box',
      animationData: iconGameGoldMiner,
      enabled: true,
    })
    // }

    // if (gameEnabled?.enableGameLuckNumber) {
    // options.push({
    //   label: 'modal-games-luck-number',
    //   key: 'luck-number',
    //   enabled: false,
    // })
    // }

    return options
  }, [gameEnabled])

  if (currentScreen === 'luck-box') {
    return <ModalGameGoldMiner handleCloseModal={handleCloseModal} />
  }

  return (
    <div className="w-screen h-screen flex flex-col flex-1 justify-end overflow-x-hidden overflow-y-scroll bg-transparent">
      <div className="h-screen flex flex-col rounded-t-xl">
        <div className="relative w-full h-full rounded-t-2xl flex flex-col justify-start overflow-hidden pt-4 px-2 bg-black/90">
          <div className="relative z-10 flex flex-col flex-1">
            <div className="grid grid-cols-4 gap-2 p-2 overflow-y-auto">
              {gameOptions.map((game) => (
                <button
                  key={game?.key}
                  type="button"
                  onClick={() => game?.enabled && openGameModal(game?.key)}
                  className={`relative z-10 flex flex-col items-center p-2 rounded-xl transition-opacity border-2 border-white/20 hover:border-white/50
                      ${game?.enabled ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
                  disabled={!game?.enabled}
                >
                  <div
                    className={`w-full pointer-events-none ${!game?.enabled ? 'opacity-80' : ''}`}
                  >
                    <Lottie
                      animationData={game.animationData}
                      loop={game?.enabled}
                      className="w-full h-full pointer-events-none"
                    />
                  </div>

                  <span className="text-base font-bold text-white text-center">
                    {translate(game?.label as Language)}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})

ModalGames.displayName = 'ModalGames'
